/**
 * View component for /sentiment-answers
 *
 * Generic sentimentAnswer list view. Defaults to 'all' with:
 * this.props.dispatch(sentimentAnswerActions.fetchListIfNeeded());
 *
 * NOTE: See /product/views/ProductList.js.jsx for more examples
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import actions
import * as sentimentAnswerActions from '../sentimentAnswerActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import sentimentAnswer components
import SentimentAnswerLayout from '../components/SentimentAnswerLayout.js.jsx';
import SentimentAnswerListItem from '../components/SentimentAnswerListItem.js.jsx';

// import sentimentAnswer css modules
import sentimentAnswerStyles from '../sentimentAnswerModuleStyles.css';

class SentimentAnswerList extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // fetch a list of your choice
    this.props.dispatch(sentimentAnswerActions.fetchListIfNeeded()); // defaults to 'all'
  }

  render() {
    const { sentimentAnswerStore } = this.props;

    /**
     * Retrieve the list information and the list items for the component here.
     *
     * NOTE: if the list is deeply nested and/or filtered, you'll want to handle
     * these steps within the mapStoreToProps method prior to delivering the
     * props to the component.  Othwerwise, the render() action gets convoluted
     * and potentially severely bogged down.
     */

    // get the sentimentAnswerList meta info here so we can reference 'isFetching'
    const sentimentAnswerList = sentimentAnswerStore.lists ? sentimentAnswerStore.lists.all : null;

    /**
     * use the reducer getList utility to convert the all.items array of ids
     * to the actual sentimentAnswer objetcs
     */
    const sentimentAnswerListItems = sentimentAnswerStore.util.getList("all");

    /**
     * NOTE: isEmpty is is usefull when the component references more than one
     * resource list.
     */
    const isEmpty = !sentimentAnswerListItems || !sentimentAnswerList;

    return (
      <SentimentAnswerLayout>
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <h1> Sentiment Answer List
                <Link className="yt-btn small u-pullRight" to={'/sentiment-answers/new'}> NEW Sentiment Answer </Link>
              </h1>
              <hr/>
              { isEmpty ?
                (sentimentAnswerListItems && sentimentAnswerList.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
                :
                <div style={{ opacity: sentimentAnswerList.isFetching ? 0.5 : 1 }}>
                  <ul>
                    {sentimentAnswerListItems.map((sentimentAnswer, i) =>
                      <SentimentAnswerListItem key={sentimentAnswer._id + i} sentimentAnswer={sentimentAnswer} />
                    )}
                  </ul>
                </div>
              }
            </div>
          </section>
        </div>
      </SentimentAnswerLayout>
    )
  }
}

SentimentAnswerList.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    sentimentAnswerStore: store.sentimentAnswer
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(SentimentAnswerList)
);



// WEBPACK FOOTER //
// modules/sentimentAnswer/views/SentimentAnswerList.js.jsx